var map = {
	"./1.svg": 95633,
	"./2.svg": 67760,
	"./3.svg": 49147,
	"./add.svg": 58475,
	"./alipay.svg": 39224,
	"./applet.svg": 86889,
	"./article-create.svg": 43545,
	"./article-ranking.svg": 98073,
	"./article.svg": 82188,
	"./auto-scale.svg": 83081,
	"./back.svg": 68802,
	"./base-data.svg": 3599,
	"./bell.svg": 74192,
	"./bind-phone.svg": 52374,
	"./branch-boke.svg": 58874,
	"./branch-frabric.svg": 27879,
	"./branch-maker.svg": 14013,
	"./branch-shop.svg": 41618,
	"./c1.svg": 73263,
	"./c2.svg": 1512,
	"./c3.svg": 6802,
	"./c4.svg": 45389,
	"./camera.svg": 57682,
	"./camera1.svg": 22198,
	"./cart-down.svg": 71161,
	"./change-theme.svg": 93920,
	"./chart.svg": 22777,
	"./close.svg": 63812,
	"./cloth.svg": 73269,
	"./code.svg": 9245,
	"./contactus.svg": 68059,
	"./customerservices.svg": 74795,
	"./dashboard.svg": 1528,
	"./data-upload.svg": 73119,
	"./deamon.svg": 85132,
	"./delete.svg": 49281,
	"./diagnosis.svg": 94103,
	"./down.svg": 95134,
	"./download (2).svg": 65427,
	"./download.svg": 85056,
	"./edit.svg": 63603,
	"./empty.svg": 58311,
	"./error.svg": 24933,
	"./example.svg": 92333,
	"./exit-fullscreen.svg": 22263,
	"./eye-open.svg": 11976,
	"./eye.svg": 38357,
	"./fullscreen.svg": 22209,
	"./gouxuan.svg": 85917,
	"./gouxuan1.svg": 31025,
	"./guide.svg": 54431,
	"./hamburger-closed.svg": 80972,
	"./hamburger-opened.svg": 23794,
	"./heart.svg": 89644,
	"./histoires.svg": 41053,
	"./home.svg": 29430,
	"./home1.svg": 48752,
	"./info.svg": 91514,
	"./international.svg": 12922,
	"./introduce.svg": 43662,
	"./language.svg": 51196,
	"./link.svg": 34751,
	"./loading.svg": 20905,
	"./loading1.svg": 67958,
	"./medtruansfer.svg": 54955,
	"./moneyaccount.svg": 17722,
	"./myreg.svg": 43022,
	"./nested.svg": 14689,
	"./new.svg": 48749,
	"./next.svg": 41058,
	"./outlinepay.svg": 19710,
	"./package.svg": 66896,
	"./password.svg": 98652,
	"./permission.svg": 63156,
	"./person.svg": 85273,
	"./personnel-info.svg": 55848,
	"./personnel-manage.svg": 22090,
	"./personnel.svg": 4105,
	"./play.svg": 6030,
	"./pointleft.svg": 6680,
	"./prev.svg": 747,
	"./qq.svg": 31337,
	"./refresh.svg": 54842,
	"./reply.svg": 12907,
	"./require.svg": 10986,
	"./reward.svg": 27422,
	"./role.svg": 91208,
	"./scales.svg": 20989,
	"./scales1.svg": 59345,
	"./search.svg": 85840,
	"./search1.svg": 39088,
	"./setting.svg": 55598,
	"./setting1.svg": 72497,
	"./shared.svg": 95129,
	"./shift.svg": 8738,
	"./shop.svg": 74597,
	"./size.svg": 17040,
	"./star.svg": 25167,
	"./success.svg": 73483,
	"./table.svg": 50547,
	"./tel.svg": 53816,
	"./tree.svg": 56257,
	"./up.svg": 16875,
	"./upload.svg": 947,
	"./user.svg": 30711,
	"./video.svg": 51039,
	"./warn.svg": 82866,
	"./wechat.svg": 51540,
	"./wx.svg": 67796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;